import React, { useState, useEffect } from "react";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";
import styles from "../commanstyles.module.css";

function SummaryByDesignatedPartnerTable({ isSubScribe, data }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [isTableOneOpen, setIsTableOneOpen] = useState(true);
  const [selectedYearPartnerContribution, setSelectedPartnerContribution] =
    useState("");
  const rowsPerPage = 10;

  // Toggle visibility of table
  const toggleTableOne = () => {
    if (!isSubScribe) {
      alert("Please unlock to see the data.");
      return;
    }
    setIsTableOneOpen((prev) => !prev);
  };

  useEffect(() => {
    const years = getAvailableYears();
    if (years.length > 0) {
      setSelectedPartnerContribution(years[0]); // Set the latest year as default
    }
  }, [data]);

  const getAvailableYears = () => {
    const years = Array.from(
      new Set(data.map((item) => item.financial_year))
    ).sort((a, b) => b - a); // Sort years in descending order
    return years;
  };

  const filteredData = data.filter((item) =>
    selectedYearPartnerContribution
      ? item.financial_year == selectedYearPartnerContribution
      : true
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage); // Calculate pages based on filtered data

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  return (
    <div className={styles.table_subcontainer}>
      {!isSubScribe && (
        <button className={styles.Subscription_msg}>
          <IoMdLock /> Subscription required to view data
        </button>
      )}

      {isSubScribe && (
        <div className={styles.highlet_header_content1}>
          <p className={styles.minuse_icon} onClick={toggleTableOne}>
            {isTableOneOpen ? (
              <FaMinusSquare size={22} />
            ) : (
              <FaPlusSquare size={22} />
            )}
          </p>
          <h3 className={styles.highlet_text}>
            CONTRIBUTION BY PARTNER
            {filteredData.length > 0 &&
              selectedYearPartnerContribution &&
              ` - 31 Mar, ${selectedYearPartnerContribution}`}
          </h3>

          {/* Financial Year Dropdown */}
          {filteredData.length > 0 && (
            <div className={styles.yearSelectContainer}>
              <select
                value={selectedYearPartnerContribution}
                onChange={(e) => setSelectedPartnerContribution(e.target.value)}
              >
                <option value="">All Years</option>
                {getAvailableYears().map((year) => (
                  <option key={year} value={year}>
                    {parseInt(year) - 1} - {year}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}

      {isTableOneOpen && isSubScribe && (
        <>
          {/* Reference Documents Section */}
          {/* <span>
            <div>
              {filteredData.map((item) => (
                <div key={item.id} className={styles.referencedoc_main}>
                  <div><b>Reference Documents</b></div>
                  <div className={styles.referencedoc_container}>
                    {item.refDoc ? (
                      <div>
                        {item.refDoc?.MaiinFileName && (
                          <a
                            href={item.refDoc?.fileurl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.referencedoc_mainfilename}
                          >
                            {item.refDoc?.MaiinFileName}
                          </a>
                        )}
                        <ul style={{ padding: 0 }}>
                          {item.refDoc?.Attachments && item.refDoc?.Attachments.length > 0 ? (
                            item.refDoc?.Attachments.map((attachment, index) => (
                              <li key={index} className={styles.referencedoc_Attachments}>
                                <IoDocumentTextOutline size={16} style={{ marginRight: "8px", color: "#2961EF" }} />
                                <a
                                  href={attachment.fileurl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: "none", color: "#2961EF" }}
                                >
                                  {attachment.Name}
                                </a>
                                <button
                                  onClick={() => {
                                    const link = document.createElement("a");
                                    link.href = attachment.fileurl;
                                    link.download = attachment.Name;
                                    link.click();
                                  }}
                                  title="Download"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "#2961EF",
                                    marginLeft: "5px",
                                    textDecoration: "underline",
                                  }}
                                >
                                  <FiDownload />
                                </button>
                              </li>
                            ))
                          ) : (
                            <span>No attachments available.</span>
                          )}
                        </ul>
                      </div>
                    ) : (
                      <span>No documents available for selected year</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </span> */}

          <table className={styles.commantable}>
            <thead>
              <tr className={styles.tableHeaderRow}>
                <th className={styles.tableHeader}>Category</th>
                <th className={styles.tableHeader}>No. of Partners</th>
                <th colSpan="2" className={styles.tableHeader}>
                  No. of Designated Partners
                </th>
                <th className={styles.tableHeader}>Total</th>
              </tr>
              <tr>
                <th className={styles.tableHeader}></th>
                <th className={styles.tableHeader}></th>
                <th className={styles.tableHeader}>Resident in India</th>
                <th className={styles.tableHeader}>Others</th>
                <th className={styles.tableHeader}></th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((row) =>
                  // Looping over categories to display individual rows for each category
                  row.categories.map((category, index) => {
                    return (
                      <tr key={index} className={styles.tableRow}>
                        <td className={styles.tableCell}>
                          {" "}
                          {index + 1}.{category.category}
                        </td>
                        <td className={styles.tableCell}>
                          {category.no_of_partners}
                        </td>
                        <td className={styles.tableCell}>
                          {category.no_of_resident_india}
                        </td>
                        <td className={styles.tableCell}>
                          {category.no_of_others}
                        </td>
                        <td className={styles.tableCell}>{category.total}</td>
                      </tr>
                    );
                  })
                )
              ) : (
                <tr>
                  <td colSpan="5" className={styles.noDataRow}>
                    No data available
                  </td>
                </tr>
              )}

              {/* Total row */}
              <tr className={styles.totalRow}>
                <td className={styles.tableCell}>Total</td>
                <td className={styles.tableCell}>
                  {/* Total No. of Partners */}
                  {currentData.reduce(
                    (acc, row) => acc + row.total.no_of_partners,
                    0
                  )}
                </td>
                <td className={styles.tableCell}>
                  {/* Total No. of Designated Partners (Resident in India) */}
                  {currentData.reduce(
                    (acc, row) => acc + row.total.no_of_resident,
                    0
                  )}
                </td>
                <td className={styles.tableCell}>
                  {/* Total No. of Designated Partners (Others) */}
                  {currentData.reduce(
                    (acc, row) => acc + row.total.no_of_others,
                    0
                  )}
                </td>
                <td className={styles.tableCell}>
                  {/* Total of All Designated Partners */}
                  {currentData.reduce(
                    (acc, row) =>
                      acc +
                      row.total.no_of_partners +
                      row.total.no_of_resident +
                      row.total.no_of_others,
                    0
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          {/* Pagination */}
          <div className={styles.pagination}>
            <button onClick={handlePrevious} disabled={currentPage === 1}>
              &lt;
            </button>
            {[...Array(totalPages).keys()].map((num) => (
              <button
                key={num + 1}
                onClick={() => handleClick(num + 1)}
                className={currentPage === num + 1 ? styles.active : ""}
              >
                {num + 1}
              </button>
            ))}
            <button onClick={handleNext} disabled={currentPage === totalPages}>
              &gt;
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default SummaryByDesignatedPartnerTable;
